// extracted by mini-css-extract-plugin
export default {"control":"OP1WebFrameWindowControl_control__aU5Z0"};